import React from 'react';

const QuestionMarkIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7161_23933)">
        <path d="M5.97266 9.39844C5.71377 9.39844 5.50391 9.18858 5.50391 8.92969C5.50391 8.6708 5.71377 8.46094 5.97266 8.46094C6.23155 8.46094 6.44141 8.6708 6.44141 8.92969C6.44141 9.18858 6.23155 9.39844 5.97266 9.39844Z" fill="#C5C5C5"/>
        <path d="M5.97266 7.28906V6.61345C5.97266 6.42028 6.10852 6.25329 6.29928 6.21141C6.98881 6.06005 7.49973 5.43956 7.47153 4.70618C7.442 3.93771 6.80853 3.31153 6.03109 3.28235C5.17604 3.25024 4.47266 3.91976 4.47266 4.75781" stroke="#C5C5C5" stroke-width="0.962501" stroke-miterlimit="10" stroke-linecap="round"/>
        <circle stroke="#C5C5C5" strokeWidth="1" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" cx={6} cy={6} r={5.5}></circle>
        {/*<path d="M8.85781 10.7344C8.0229 11.2401 7.04352 11.5312 5.99609 11.5312C2.9413 11.5312 0.464844 9.05482 0.464844 6C0.464844 2.94516 2.9413 0.46875 5.99609 0.46875C9.05091 0.46875 11.5273 2.94516 11.5273 6C11.5273 7.13595 11.1771 8.1919 10.5898 9.07031" stroke="#C5C5C5" strokeWidth="0.962501" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>*/}
      </g>
      <defs>
        <clipPath id="clip0_7161_23933">
          <rect width="12" height="12" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default QuestionMarkIcon;
